<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>

<script>
import { userData } from '@/api'
import { useGlobalStore } from '@/store'
import { computed, onMounted } from 'vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn.mjs'
import enUs from 'element-plus/es/locale/lang/en.mjs'

export default {
  name: 'App',
  setup() {
    const store = useGlobalStore()
    const locale = computed(() => {
      return store.locale === 'zh' ? zhCn : enUs
    })

    const getUserData = async () => {
      try {
        const res = await userData({
          token: localStorage.getItem('token') || ''
        })
        store.setUserData(res)
      } catch (e) {
        console.error(e)
      }
    }
    getUserData()

    onMounted(() => {
      const isDark = localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
      document.documentElement.classList.toggle(
          'dark',
          isDark
      )
      store.setTheme(isDark ? 'dark' : 'light')
    })

    return {
      locale
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
